import Entity from './entity'
export default class TrapThData extends Entity<number>{
    
}